import React, { Component } from "react";
import { connect } from "react-redux";
import { IdProofComponent } from "../components";
import { saveIDProof, saveIDProofBackSide, saveIDProofFrontSide, resetIdProof } from "../actions";
import { updateRequestState, getRequestState } from "../../../shared/actions";
import { isEqual } from "lodash";
import { getContent } from "../../../utils/helper";
import { ID_PC, AD_AC, AD_VC, AD_DL, OTHER_PROOF } from "../../../assets/images";
import { PROOF_TYPE, PROOF_KEYS } from "../../../utils/constant";

class IdProof extends Component {
   constructor(props) {
      super(props);
      this.idProofList = [
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_PAN), value: PROOF_TYPE.PAN, image: ID_PC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_AADHAR), value: PROOF_TYPE.AADHAAR, image: AD_AC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_VOTER_ID), value: PROOF_TYPE.VID, image: AD_VC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_DL), value: PROOF_TYPE.DL, image: AD_DL },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_OTHER), value: PROOF_TYPE.OTHER, image: OTHER_PROOF },
      ];

      let selectedIdProofOption = this.idProofList.find((item) => item.value === props.idProof);
      this.state = {
         step: 1,
         selectedIdProofOption: selectedIdProofOption ? selectedIdProofOption : "",
         idProofFrontSide: props.idProofFrontSide,
         idProofBackSide: props.idProofBackSide,
         isCameraOn: false,
      };
   }

   componentDidMount = () => {
      this.props.getRequestState();
      if (this.props.history.location.params && this.props.history.location.params.to === "preview") {
         this.resetIdProof();
      } else if (this.state.selectedIdProofOption) {
         this.setState({ step: 2 });
      }
   };

   componentDidUpdate = (prevProps) => {
      if (!isEqual(prevProps.idProof, this.props.idProof) && this.props.idProof) {
         this.setState({ selectedIdProofOption: this.idProofList.find((item) => item.value === this.props.idProof) });
      }
      if (!isEqual(prevProps.idProofFrontSide, this.props.idProofFrontSide) && this.props.idProofFrontSide) {
         this.setState({ idProofFrontSide: this.props.idProofFrontSide });
      }
      if (!isEqual(prevProps.idProofBackSide, this.props.idProofBackSide) && this.props.idProofBackSide) {
         this.setState({ idProofBackSide: this.props.idProofBackSide });
      }
   };

   handleChange = (key, value) => {
      this.setState({ [key]: value });
   };

   goToScreen = (key, params) => {
      if (this.props.history.location && this.props.history.location.params) {
         this.props.history.push(this.props.history.location.params.to);
      } else {
         this.props.history.push({
            pathname: key,
            params: params,
         });
      }
   };

   resetIdProof = () => {
      this.setState({ step: 1, idProofFrontSide: "", idProofBackSide: "", selectedIdProofOption: "" });
      this.props.resetIdProof();
   };

   goBack = () => {
      if (this.state.step === 2) {
         this.resetIdProof();
      } else {
         this.props.history.replace("selfie");
      }
   };

   captureImage = (key, image) => {
      this.setState({ step: 2, [key]: image });
   };

   submit = () => {
      const { idProofFrontSide, idProofBackSide, selectedIdProofOption } = this.state;
      const { idProof, requestState } = this.props;

      //if any of the field is updated we need to call the update state API but we need to upload to s3 only those that have actually changed
      if (
         !isEqual(selectedIdProofOption.value, idProof) ||
         !isEqual(idProofFrontSide, this.props.idProofFrontSide) ||
         !isEqual(idProofBackSide, this.props.idProofBackSide)
      ) {
         let upload = [];
         let data = {};
         if (
            !isEqual(idProofFrontSide, this.props.idProofFrontSide) &&
            !isEqual(idProofBackSide, this.props.idProofBackSide)
         ) {
            upload = idProofBackSide ? ["id_frontside", "id_backside"] : ["id_frontside"];
            data = {
               id_type: selectedIdProofOption.value,
               id_backside: idProofBackSide,
               id_frontside: idProofFrontSide,
            };
         } else if (!isEqual(idProofFrontSide, this.props.idProofFrontSide)) {
            upload = ["id_frontside"];
            data = {
               id_type: selectedIdProofOption.value,
               id_backside: (requestState.data && requestState.data.id_backside) || "",
               id_frontside: idProofFrontSide,
            };
         } else if (!isEqual(idProofBackSide, this.props.idProofBackSide)) {
            upload = idProofBackSide ? ["id_backside"] : [];
            data = {
               id_type: selectedIdProofOption.value,
               id_backside: idProofBackSide,
               id_frontside: (requestState.data && requestState.data.id_frontside) || "",
            };
         }

         this.props.updateRequestState({
            upload: upload,
            state: "id_proof_captured",
            data: data,
            nextRoute: "idPhoto",
         });
      } else {
         this.goToScreen("idPhoto");
      }
   };

   render() {
      const { language, languageJSON } = this.props;
      const { step, idProofFrontSide, idProofBackSide, selectedIdProofOption, isCameraOn } = this.state;
      return (
         <IdProofComponent
            step={step}
            isCameraOn={isCameraOn}
            idProofFrontSide={idProofFrontSide}
            idProofBackSide={idProofBackSide}
            goBack={this.goBack}
            goToScreen={this.goToScreen}
            language={language}
            languageJSON={languageJSON}
            captureImage={this.captureImage}
            submit={this.submit}
            selectedIdProofOption={selectedIdProofOption}
            handleChange={this.handleChange}
            saveIDProof={this.props.saveIDProof}
            idProofList={this.idProofList}
         />
      );
   }
}

const mapStateToProps = ({
   idProof: { idProof, idProofFrontSide, idProofBackSide },
   language: { language, languageJSON },
   shared: { requestState },
}) => ({
   language,
   languageJSON,
   idProof,
   idProofFrontSide,
   idProofBackSide,
   requestState,
});

const mapDispatchToProps = {
   saveIDProof,
   saveIDProofBackSide,
   saveIDProofFrontSide,
   resetIdProof,
   updateRequestState,
   getRequestState,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdProof);
